<template>
  <div class="historicalRank">
    <div class="search-box">
      <div class="examine-box">
        <TabBar :list="examineTabList" v-model="searchForm.status" @change="changeStatusTab"/>
      </div>
      <el-form inline :model="searchForm" class="demo-form-inline">
        <el-form-item>
          <TabBar :list="tabList" v-model="tabIndex" @change="changeTab"/>
        </el-form-item>
        <el-form-item v-if="tabIndex === '4'">
          <el-date-picker
            clearable
            class="form-time-select"
            v-model="date"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="changeDate"
            popper-class="form-time-select-dropdown form-time-picker-dropdown"
          ></el-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <TableBox class="table-box" id="table-box" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.8)">
      <div class="table-title-box">
        <div class="table-title">火点考核</div>
        <div class="table-title table-title-e">能效考核</div>
      </div>
      <Fire :show="!loading" :height="tableHeight" :table-data="fireTableData" :tabindex="searchForm.status"/>
    </TableBox>
  </div>
</template>

<script>
import TabBar from "../../RealTimeScheduling/DataScreen/common/TabBar";
import TableBox from '@/components/ClipBox/index.vue'
import Fire from "./components/Fire";
import { getFireWarningHistoryRanking } from "../../../api/dataCenter";
import { changeDateTab } from "../../../utils/time";

export default {
  name: "index",
  components: { TabBar, TableBox, Fire },
  data () {
    return {
      date: null,
      tableHeight: 600,
      loading: false,
      tabIndex: "0",
      searchForm: {
        startTime: '',
        endTime: '',
        status: 3 // 审核状态(3:未审核，4:已审核)
      },
      examineTabList: [
        { label: '未审核', value: 3 },
        { label: '已审核', value: 4 }
      ],
      tabList: [
        { label: "今日", value: "0" },
        { label: "本月", value: "2" },
        { label: "今年", value: "3" },
        { label: "自定义", value: "4" }
      ],
      fireTableData: [
        {name: 1},{name: 1},{name: 1},{name: 1},{name: 1},{name: 1},{name: 1},{name: 1}
      ]
    }
  },
  mounted() {
    this.setTableHeight()
    window.addEventListener('resize', () => {
      this.setTableHeight()
    })
    this.changeTab('0')
  },
  methods: {
    setTableHeight () {
      this.$nextTick(() => {
        this.tableHeight = document.getElementById('table-box').offsetHeight - 60
      })
    },
    changeDate (date) {
      if (date === null) {
        this.searchForm.startTime = ''
        this.searchForm.endTime = ''
      } else {
        this.searchForm.startTime = date[0]
        this.searchForm.endTime = date[1]
      }
      this.getList()
    },
    changeStatusTab () {
      this.getList()
    },
    changeTab (val) {
      const date = changeDateTab(val)
      if (date === null ) {
        return false
      } else {
        this.searchForm.startTime = date[0]
        this.searchForm.endTime = date[1]
        this.getList()
      }
    },
    getList () {
      this.loading = true
      getFireWarningHistoryRanking(this.searchForm).then(res => {
        this.fireTableData = res.data
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style scoped lang="less">
.historicalRank{
  height: 100%;
  .search-box{
    width: 100%;
    display: flex;
    justify-content: flex-end;
    padding-top: 15px;
    position: relative;
    .examine-box{
      position: absolute;
      left: 0;
    }
  }
  .table-box{
    width: 100%;
    height: calc(100% - 90px);
    .table-title-box{
      width: 100%;
      display: flex;
      .table-title{
        flex: 1;
        height: 60px;
        background-size: 100% 100%;
        font-family: 'YouSheBiaoTiHei';
        font-size: 32px;
        font-weight: 400;
        line-height: 60px;
        color: #FFFFFF;
        text-align: center;
        background-image: url("./assets/Vector.png");
      }
      .table-title-e{
        background-image: url("./assets/Vector2.png");
      }
    }
  }
}
/deep/ .el-input__inner {
  width: 100%;
  //height: 40px;
  font-size: 18px;
  line-height: inherit;
  font-weight: 500;
  background: rgba(0, 45, 65, 0.2);
  border: 1px solid #00B2FF;
  color: #00B2FF;
  border-radius: 0 !important;
  box-shadow: 0 0 12px 4px rgba(0, 178, 255, 0.2) inset;

  &::-webkit-input-placeholder {
    color: rgba(0, 178, 255, 0.3);
  }
}
/deep/ .el-form-item__label{
  color: #FFFFFF;
  font-size: 18px;
}
/deep/ .el-form-item{
  margin-bottom: 15px;
}
/deep/ .tab-bar{
  height: 41px;
  .tab-txt{
    font-size: 16px;
  }
  .tab-item{
    padding: 2px 5px;
  }
}
</style>
